import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { getGeo } from "@/lib/geo";
import { trackEvent } from "@/lib/track";

export const RouteTracker = () => {
  const location = useLocation();
  const scrolledRef = useRef<{ p50: boolean; p90: boolean }>({ p50: false, p90: false });

  useEffect(() => {
    if (location.pathname.startsWith("/kalaradi6")) return;

    (async () => {
      const g = await getGeo();
      await supabase.from("visitors").insert({
        page: location.pathname + location.search + location.hash,
        ip_address: g.ip,
        country_code: g.country_code,
        country_name: g.country_name,
        city: g.city,
        referrer: document.referrer || null,
      });
    })();

    // reset scroll markers on route change
    scrolledRef.current = { p50: false, p90: false };

    const onScroll = () => {
      const h = document.documentElement;
      const scrolled = (h.scrollTop + window.innerHeight) / h.scrollHeight;
      if (!scrolledRef.current.p50 && scrolled >= 0.5) {
        scrolledRef.current.p50 = true;
        trackEvent("scroll-50");
      }
      if (!scrolledRef.current.p90 && scrolled >= 0.9) {
        scrolledRef.current.p90 = true;
        trackEvent("scroll-90");
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [location.pathname, location.search, location.hash]);

  return null;
};
